import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import initAjax from '../util/ajax';
import blackBox from '../black-box/store';
import main from '../modules/main/store';
import home from '../modules/home/store';
import canvas from '../modules/canvas/store';
import center from '../modules/center/store';

import {
    SYSTEM_SETTING,
} from './api/home';

Vue.use(Vuex);

export default new Vuex.Store({
    state: { // 全局state
        app: {
            global: {},
            router: {},
            $http: axios,
            $notify: {},
            $loading: {},
            doInitAjax: initAjax,
            i18n: {},
            lang: 'cn'
        },
    },
    getters: {
        getOAuth: state => state.app.global.OAuth
    },
    mutations: { // 全局mutations
        setOauth(state) { // 初始化登录相关逻辑和token
            state.app.doInitAjax(state.app.$http, state.app);
        },
        setPublicComponent(state, payload) { // 保存一些全局通用组件
            state.app.$info = payload.$message.info;
            state.app.$loading = payload.$spin;
            state.app.$notify.error = (obj) => {
                payload.$notification.error({ message: obj.message, duration: 2.5 });
            };
            state.app.$notify.success = (obj) => {
                payload.$notification.success({ message: obj.message, duration: 2.5 });
            };
        },
        setI18N(state, payload) { // 缓存国际化语言包对象实例
            state.app.i18n = payload;
        },
        setRouter(state, payload) { // 缓存对应的路由对象实例
            state.app.router = payload;
        },
        setGlobalData(state, payload) { // 保存异步获取的系统配置数据
            const dataPermission = {};
            if (payload.dataPermission) {
                payload.dataPermission.forEach((v) => {
                    dataPermission[v.code] = v;
                });
            }
            Object.assign(state.app.global, { currentUser: {} }, payload);
            state.app.global.dataPermission = dataPermission;
        },
    },
    actions: { // 全局actions
        requestGlobalSystemData({ state }, payload) { // 异步获取系统配置数据
            return state.app.$http.all([
                (function () { return state.app.$http.get(`${SYSTEM_SETTING}/${payload.zxyToken}?uri=${payload.url}`); }()),
            ]).then(state.app.$http.spread((sysData) => {
                return Object.assign({}, sysData.data);
            }));
        },
        // requestIsOpen({ state }, payload) {
        //     return state.app.$http.post(ISOPEN, payload);
        // }
        // requestSiteDomain({ state, commit }, payload) {
        //     state.app.$http.get(DOMAIN, payload).then((res) => {
        //         commit('setSiteDomain', Object.assign({}, { domain: res.data.f_sync_address }));
        //     });
        // }
    },
    modules: {
        main,
        blackBox,
        canvas,
        home,
        center
    },
});
